import { Chip } from '@mui/material';

interface TagProps {
    label: string;
}

/**
 * Chip do MUI personalizado baseado na cor principal do tema
 */
export function Tag({ label }: TagProps) {
    return (
        <Chip
            size="small"
            label={label}
            sx={{
                color: 'secondary.main',
                backgroundColor: (theme) => theme.alpha(theme.palette.primary.main, 0.2),
                mr: 1,
            }}
        />
    );
}
